import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Input,
  Label,
  Collapse
} from "reactstrap"
import rest from '../../lib/rest'
import rotas from '../../services/rotas'
import Loading from 'lib/loading'
import './style.css'

const FromCaixaFpagtos = ({ fechaModal, caixa_id, filial_id}) => {

  const [form, setForm] = useState('')
  const [loading, setLoading] = useState(true)
  const [expandCartao, setExpandCartao] = useState({ geral: false, vendas: false, receb: false })

  const hasCartaoTipo = (tipo) => tipo && !Array.isArray(tipo) && Object.keys(tipo).length > 0
  const toggleCartao  = (secao) => setExpandCartao(prev => ({ ...prev, [secao]: !prev[secao] }))

  const editCaixa = (caixa_id, filial_id) => {
    const url = rotas.caixaFpagtos+filial_id+'/'+caixa_id
    const retorno = rest.get(url)
    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista != '') {
        let caixa = ret.lista[0]

        // caixa.caixa_dinheiro      = parseFloat(caixa.receb_dinheiro) + parseFloat(caixa.vendas_dinheiro)
        caixa.caixa_dinheiro      = parseFloat(caixa.caixa_dinheiro)
        caixa.caixa_cheque        = parseFloat(caixa.caixa_cheque)
        caixa.caixa_cheque_pre    = parseFloat(caixa.caixa_cheque_pre)
        caixa.caixa_cartao        = parseFloat(caixa.caixa_cartao)
        caixa.caixa_crediario     = parseFloat(caixa.caixa_crediario)
        caixa.caixa_parcelamento  = parseFloat(caixa.caixa_parcelamento)
        caixa.caixa_outros        = parseFloat(caixa.caixa_outros)
        caixa.caixa_recarga       = parseFloat(caixa.caixa_recarga)
        caixa.caixa_suprimento    = parseFloat(caixa.caixa_suprimento)
        caixa.caixa_sangria       = parseFloat(caixa.caixa_sangria)
        caixa.devolucoes_vista    = parseFloat(caixa.vendas_devolucoes_vista)
        caixa.frete               = parseFloat(caixa.frete)
        caixa.caixa_total         = parseFloat(caixa.caixa_total)
        
        caixa.vendas_dinheiro       = parseFloat(caixa.vendas_dinheiro)
        caixa.vendas_cheque         = parseFloat(caixa.vendas_cheque)
        caixa.vendas_cheque_pre     = parseFloat(caixa.vendas_cheque_pre)
        caixa.vendas_cartao         = parseFloat(caixa.vendas_cartao)
        caixa.vendas_crediario      = parseFloat(caixa.vendas_crediario)
        caixa.vendas_parcelamento   = parseFloat(caixa.vendas_parcelamento)
        caixa.vendas_outros         = parseFloat(caixa.vendas_outros)
        caixa.vendas_descontos      = parseFloat(caixa.vendas_desconto)
        caixa.vendas_subsidio       = parseFloat(caixa.vendas_subsidio)
        caixa.vendas_pix_penseBank  = parseFloat(caixa.vendas_pix_penseBank)
        caixa.vendas_mercadoPago    = parseFloat(caixa.vendas_mercadoPago)
        caixa.vendas_pix            = parseFloat(caixa.vendas_pix)
        caixa.devolucoes            = parseFloat(caixa.vendas_devolucoes)
        caixa.total_vendas          = parseFloat(caixa.vendas_total)
        
        caixa.receb_dinheiro        = parseFloat(caixa.receb_dinheiro)
        caixa.receb_cheque          = parseFloat(caixa.receb_cheque)
        caixa.receb_cheque_pre      = parseFloat(caixa.receb_cheque_pre)
        caixa.receb_cartao          = parseFloat(caixa.receb_cartao)
        caixa.receb_outros          = parseFloat(caixa.receb_outros)
        caixa.outras_lojas          = parseFloat(caixa.receb_outras_lojas)
        caixa.total_recebimento     = parseFloat(caixa.receb_total)
        caixa.receb_total_geral     = parseFloat(caixa.receb_total_geral)
        caixa.desconto_recebimento  = parseFloat(caixa.desconto_recebimento)

        caixa.receb_pix_penseBank   = parseFloat(caixa.receb_pix_penseBank)
        caixa.receb_mercadoPago     = parseFloat(caixa.receb_mercadoPago)
        caixa.receb_pix             = parseFloat(caixa.receb_pix)

        caixa.caixa_pix_penseBank   = parseFloat(caixa.caixa_pix_penseBank)
        caixa.caixa_mercadoPago     = parseFloat(caixa.caixa_mercadoPago)
        
        setForm(caixa)
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if(caixa_id != ''){
      editCaixa(caixa_id, filial_id)
    }else{
      setForm('')
      setLoading(false)
    }
  },[])


  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    return (
      <Row>
        <Col md='4'>
          <div className="card-2">
            <Col>
              <span className="tag-card">Caixa e loja</span>
              <div><span><b>{form.caixa_id}</b></span></div>
              <span>{form.fantasia}</span>
            </Col>
          </div>
        </Col>
        <Col md='4'>
          <div className="card-2">
            <Col>
              <span className="tag-card">Data de Abertura</span>
              <div><b>{form.abertura}</b></div>{form.operador_abertura}
            </Col>
          </div>
        </Col>
        <Col md='4'>
          <div className="card-2">
            <Col>
              <span className="tag-card">Data de Fechamento</span>
              {form.fechamento ? <><div> <b>{form.fechamento}</b></div> {form.operador_fechamento}</>: <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Aberto</span></div>}
            </Col>
          </div>
        </Col>

        <Col md='4'>
          {/* <div className="card-2">
            <Col>
              <span className="tag-card">Caixa e loja</span>
              <span><b>{form.caixa_id}</b> - {form.fantasia}</span>
            </Col>
          </div> */}
          <div className="card-2">
            <Col>
              <span className="tag-card">Geral</span>
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Dinheiro</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "dinheiro"
                    id    = "dinheiro"
                    value = {form.caixa_dinheiro.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque</Label>
                </Col>
                <Col md='8'>
                <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "cheque"
                    id    = "cheque"
                    value = {form.caixa_cheque.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque-pré</Label>
                </Col>
                <Col md='8'>
                <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "cheque_pre"
                    id    = "cheque_pre"
                    value = {form.caixa_cheque_pre.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label className="d-flex align-items-center">
                    Cartão
                    {hasCartaoTipo(form.caixa_cartao_tipo) &&
                      <i
                        className={`fas fa-chevron-${expandCartao.geral ? 'up' : 'down'} ml-2`}
                        style={{ fontSize: '0.7rem', cursor: 'pointer', color: '#6c757d' }}
                        onClick={() => toggleCartao('geral')}
                      />
                    }
                  </Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "cartao"
                    id    = "cartao"
                    value = {form.caixa_cartao.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              <Collapse isOpen={expandCartao.geral}>
                {hasCartaoTipo(form.caixa_cartao_tipo) && Object.entries(form.caixa_cartao_tipo).map(([tipo, valor]) => (
                  <Row className="mb-1" key={tipo}>
                    <Col md='4' className="p-0 m-auto">
                      <Label style={{ fontSize: '0.8rem', color: '#6c757d', paddingLeft: '12px' }}>{tipo}</Label>
                    </Col>
                    <Col md='8'>
                      <Input disabled type="text" style={{ background: '#f5f5f5', fontSize: '0.85rem', height: '30px', padding: '2px 8px' }}
                        value={parseFloat(valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})} />
                    </Col>
                  </Row>
                ))}
              </Collapse>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Crediário</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "crediario"
                    id    = "crediario"
                    value = {form.caixa_crediario.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Parcelamento</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "parcelamento"
                    id    = "parcelamento"
                    value = {form.caixa_parcelamento.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Outros</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "outros"
                    id    = "outros"
                    value = {form.caixa_outros.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              {form.caixa_pix_penseBank > 0 ?
                <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>PenseBank</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "caixa_pix_penseBank"
                    id    = "caixa_pix_penseBank"
                    value = {form.caixa_pix_penseBank.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              : ''}

              {form.caixa_mercadoPago > 0 ?
                <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>MercadoPago</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "caixa_mercadoPago"
                    id    = "caixa_mercadoPago"
                    value = {form.caixa_mercadoPago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              : ''}

              {form.caixa_pix > 0 ?
                <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Pix</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "caixa_pix"
                    id    = "caixa_pix"
                    value = {form.caixa_pix.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              : ''}

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Recargas</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "recarga"
                    id    = "recarga"
                    value = {form.caixa_recarga.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Suprimento</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "suprimento"
                    id    = "suprimento"
                    value = {form.caixa_suprimento.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Sangria</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#ff7f7f'}}
                    name  = "sangria"
                    id    = "sangria"
                    value = {form.caixa_sangria.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Devoluções A Vista</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#FFD54F'}}
                    name  = "devolucoes_vista"
                    id    = "devolucoes_vista"
                    value = {form.devolucoes_vista.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Frete</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#F9F9F9'}}
                    name  = "frete"
                    id    = "frete"
                    value = {form.frete.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Total</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "caixa_total"
                    id    = "caixa_total"
                    value = {form.caixa_total.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
            </Col>
          </div>
        </Col>

        <Col md='4'>
          {/* <div className="card-2">
            <Col>
              <span className="tag-card">Data de Abertura</span>
              {form.abertura} - {form.operador_abertura}
            </Col>
          </div> */}
          <div className="card-2">
            <Col>
              <span className="tag-card">Vendas</span>
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Dinheiro</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_dinheiro"
                    id    = "vendas_dinheiro"
                    value = {form.vendas_dinheiro.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_cheque"
                    id    = "vendas_cheque"
                    value = {form.vendas_cheque.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque-pré</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_cheque_pre"
                    id    = "vendas_cheque_pre"
                    value = {form.vendas_cheque_pre.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label className="d-flex align-items-center">
                    Cartão
                    {hasCartaoTipo(form.vendas_cartao_tipo) &&
                      <i
                        className={`fas fa-chevron-${expandCartao.vendas ? 'up' : 'down'} ml-2`}
                        style={{ fontSize: '0.7rem', cursor: 'pointer', color: '#6c757d' }}
                        onClick={() => toggleCartao('vendas')}
                      />
                    }
                  </Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "vendas_cartao"
                    id    = "vendas_cartao"
                    value = {form.vendas_cartao.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              <Collapse isOpen={expandCartao.vendas}>
                {hasCartaoTipo(form.vendas_cartao_tipo) && Object.entries(form.vendas_cartao_tipo).map(([tipo, valor]) => (
                  <Row className="mb-1" key={tipo}>
                    <Col md='4' className="p-0 m-auto">
                      <Label style={{ fontSize: '0.8rem', color: '#6c757d', paddingLeft: '12px' }}>{tipo}</Label>
                    </Col>
                    <Col md='8'>
                      <Input disabled type="text" style={{ background: '#f5f5f5', fontSize: '0.85rem', height: '30px', padding: '2px 8px' }}
                        value={parseFloat(valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})} />
                    </Col>
                  </Row>
                ))}
              </Collapse>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Crediário</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_crediario"
                    id    = "vendas_crediario"
                    value = {form.vendas_crediario.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Parcelamento</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_parcelamento"
                    id    = "vendas_parcelamento"
                    value = {form.vendas_parcelamento.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Outros</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_outros"
                    id    = "vendas_outros"
                    value = {form.vendas_outros.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              {form.vendas_pix_penseBank > parseFloat(0) ?
                <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>PenseBank</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    // style  = {{background: '#F9F9F9'}}
                    name  = "vendas_pix_penseBank"
                    id    = "vendas_pix_penseBank"
                    value = {form.vendas_pix_penseBank.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              : ''}

              {form.vendas_mercadoPago > parseFloat(0) ?
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>MercadoPago</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "vendas_mercadoPago"
                    id    = "vendas_mercadoPago"
                    value = {form.vendas_mercadoPago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row> 
              : ''}

             {form.vendas_pix > parseFloat(0) ?
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Pix</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "vendas_pix"
                    id    = "vendas_pix"
                    value = {form.vendas_pix.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              : ''}

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Desconto</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#ff7f7f'}}
                    name  = "vendas_descontos"
                    id    = "vendas_descontos"
                    value = {form.vendas_descontos.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Subsidio</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#66b2ff'}}
                    name  = "vendas_subsidio"
                    id    = "vendas_subsidio"
                    value = {form.vendas_subsidio.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Devoluções</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#FFD54F'}}
                    name  = "devolucoes"
                    id    = "devolucoes"
                    value = {form.devolucoes.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Total</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "total_vendas"
                    id    = "total_vendas"
                    value = {form.total_vendas.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
            </Col>
          </div>
        </Col>

        <Col md='4'>
          {/* <div className="card-2">
            <Col>
              <span className="tag-card">Data de Fechamento</span>
              {form.fechamento ? form.fechamento+' - '+form.operador_fechamento: <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Aberto</span></div>}
            </Col>
          </div> */}
          <div className="card-2">
            <Col>
              <span className="tag-card">Recebimentos</span>
              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Dinheiro</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_dinheiro"
                    id    = "receb_dinheiro"
                    value = {form.receb_dinheiro.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_cheque"
                    id    = "receb_cheque"
                    value = {form.receb_cheque.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Cheque-pré</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_cheque_pre"
                    id    = "receb_cheque_pre"
                    value = {form.receb_cheque_pre.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label className="d-flex align-items-center">
                    Cartão
                    {hasCartaoTipo(form.receb_cartao_tipo) &&
                      <i
                        className={`fas fa-chevron-${expandCartao.receb ? 'up' : 'down'} ml-2`}
                        style={{ fontSize: '0.7rem', cursor: 'pointer', color: '#6c757d' }}
                        onClick={() => toggleCartao('receb')}
                      />
                    }
                  </Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_cartao"
                    id    = "receb_cartao"
                    value = {form.receb_cartao.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              <Collapse isOpen={expandCartao.receb}>
                {hasCartaoTipo(form.receb_cartao_tipo) && Object.entries(form.receb_cartao_tipo).map(([tipo, valor]) => (
                  <Row className="mb-1" key={tipo}>
                    <Col md='4' className="p-0 m-auto">
                      <Label style={{ fontSize: '0.8rem', color: '#6c757d', paddingLeft: '12px' }}>{tipo}</Label>
                    </Col>
                    <Col md='8'>
                      <Input disabled type="text" style={{ background: '#f5f5f5', fontSize: '0.85rem', height: '30px', padding: '2px 8px' }}
                        value={parseFloat(valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})} />
                    </Col>
                  </Row>
                ))}
              </Collapse>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Outros</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_outros"
                    id    = "receb_outros"
                    value = {form.receb_outros.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              {form.receb_pix > parseFloat(0) ?
                <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Pix</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_pix"
                    id    = "receb_pix"
                    value = {form.receb_pix.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              : ''}

              {form.receb_pix_penseBank > parseFloat(0) ?
                <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>PenseBank</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_pix_penseBank"
                    id    = "receb_pix_penseBank"
                    value = {form.receb_pix_penseBank.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              : ''}

              {form.receb_mercadoPago > parseFloat(0) ?
                <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>MercadoPago</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    name  = "receb_mercadoPago"
                    id    = "receb_mercadoPago"
                    value = {form.receb_mercadoPago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
              : ''}

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Desconto</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#ff7f7f'}}
                    name  = "desconto_recebimento"
                    id    = "desconto_recebimento"
                    value = {form.desconto_recebimento.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Subtotal</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "total_recebimento"
                    id    = "total_recebimento"
                    value = {form.total_recebimento.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Outras Lojas</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#FFD54F'}}
                    name  = "outras_lojas"
                    id    = "outras_lojas"
                    value = {form.outras_lojas.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='4' className="p-0 m-auto">
                  <Label>Total</Label>
                </Col>
                <Col md='8'>
                  <Input
                    disabled
                    type  = "text"
                    style  = {{background: '#aafc96'}}
                    name  = "receb_total_geral"
                    id    = "receb_total_geral"
                    value = {form.receb_total_geral.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                  />
                </Col>
              </Row>
            </Col>
          </div>

          {/* <div className="card-2">
            <Col>
              <span className="tag-card">Número do caixa</span>
              <span>{form.caixa_id}</span>
            </Col>
          </div> */}
{/* 
          <div className="card-2">
            <Col>
              <span className="tag-card">Loja</span>
              <span>{form.fantasia}</span>
            </Col>
          </div>

          <div className="card-2">
            <Col>
              <span className="tag-card">Data de Abertura</span>
              {form.abertura} - {form.operador_abertura}
              
            </Col>
          </div>

          <div className="card-2">
            <Col>
              <span className="tag-card">Data de Fechamento</span>
              {form.fechamento ? form.fechamento+' - '+form.operador_fechamento: ''}
            </Col>
          </div> */}

        </Col>
        <Col className="text-center p-3">
          <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
        </Col>
      </Row>
    )
  }

}


export default FromCaixaFpagtos
